module.exports = __webpack_public_path__ + "media/images/expert-slide1-thumb-5da2695f735eb89ebc0a0a13263a1e4a13ddb995153a5023078d520df7081f49.jpg";